(function(angular, _) {
'use strict';

angular.module('GorillaBoy.DocumentViewer')
.controller('DocumentFeedbackFilterPanelController', [
    '$scope',
    '$filter',
    '$translate',
    'DocumentStateService',
    'AppConstants',
    DocumentFeedbackFilterPanelController
]);

function DocumentFeedbackFilterPanelController($scope, $filter, $translate, DocumentStateService, AppConstants) {
    var collaboratorTypes = AppConstants.CollaboratorTypes;
    //Maps each documentState.documentVersions.versionId with the rendered version number
    //at the moment of creating <li> elements
    var versionIdMap = {};
    var allVersionsLabel = $translate.instant('RIGHT_NAV.FEEDBACK_PANEL.FILTER_PANEL.ALL_VERSIONS');
    var titleCheckoutLegend = $translate.instant('DOCUMENT_VIEW.VERSION_TITLE_CHECKED_OUT');
    var allUsersLabel = $translate.instant('RIGHT_NAV.FEEDBACK_PANEL.FILTER_PANEL.ALL_USERS');


    //When the filter panel loads, initialize the 'localCommentFilterPreferenceMap' on this scope as a copy of the real object
    //The intention is to NOT apply these filtering criteria if the user doesn't click Apply button but navigates away from filter panel
    //after doing half the selection. This approach is used in the Activity Feed filtering panel as well.
    $scope.localCommentFilterPreferenceMap = angular.copy($scope.documentState.commentFilterPreferenceMap);

    //This variable is necessary to cache the "result", otherwise angular goes into infdigest
    var listOfVersions;
    
    $scope.usersListFromFeedbackList = [];
    Object.keys($scope.documentState.feedbackListMap).forEach(function(versionId) {
        if (!versionId) {
            return;
        }
        var feedbackSections = $scope.documentState.feedbackListMap[versionId];
        if (!feedbackSections) {
            return;
        }
        feedbackSections.forEach(function(feedbackSection) {
            if (!feedbackSection) {
                return;
            }
            return feedbackSection.forEach(function(feedbackObj) {
                if (feedbackObj.Contributor) {
                    $scope.usersListFromFeedbackList.push(feedbackObj.Contributor);
                }
                if (feedbackObj.Replies) {
                    return feedbackObj.Replies.some(function(feedbackObj) {
                        if (feedbackObj.Contributor) {
                            $scope.usersListFromFeedbackList.push(feedbackObj.Contributor);           
                        }
                    });
                }
            });
        });
    });
    $scope.usersListFromFeedbackList = _.sortBy(_.uniqBy($scope.usersListFromFeedbackList, 'Id'), 'GivenName');

    $scope.getVersionsList = function() {
        var newList = [];
        angular.forEach($scope.documentState.documentVersions, function(docVersion, index) {
            newList.push({
                label: $translate.instant(docVersion.VersionStatus !== 'DRAFT' ? 'DOCUMENT_VIEW.VERSION_TITLE' : 'DOCUMENT_VIEW.VERSION_TITLE_CHECKED_OUT', {
                    versionId: $scope.documentState.documentVersions.length - index
                }),
                value: docVersion.VersionId
            });
        });
        if (!angular.equals(listOfVersions, newList)) {
            listOfVersions = newList;
        }

        return listOfVersions; 
    };

    $scope.onVersionSelect = function($item) {
        $scope.localCommentFilterPreferenceMap.version = $item.value;
    };
    $scope.onUserSelect = function($item) {
        $scope.localCommentFilterPreferenceMap.user = $item.Id;  
    };

    $scope.hasFilterCriteriaChanged = function() {
        return !angular.equals($scope.documentState.commentFilterPreferenceMap, $scope.localCommentFilterPreferenceMap);
    };

    $scope.getApplyButtonText = function() {
        if ($scope.hasFilterCriteriaChanged()) {
            return $translate.instant('ANALYTICS.FILTER.BUTTONS.APPLY');
        } else {
            return $translate.instant('GENERAL_LABELS.BACK');
        }
    };
    
    $scope.onFilterForPublishedCommentChanged = function() {
        var preferenceMap = $scope.localCommentFilterPreferenceMap;
        if (!preferenceMap.published) {
            preferenceMap.resolved = preferenceMap.unresolved = false;
        } else {
            preferenceMap.unresolved = true;
            preferenceMap.resolved = false;
        }
    };

    /**
     * The user actions are recorded on local copy of commentFilterPreferenceMap object. After user clicks Apply Filters
     * this object copy is assigned to the master copy (documentState.commentFilterPreferenceMap)
     */
    $scope.applyFeedbackFiltersInternal = function() {
        $scope.documentState.commentFilterPreferenceMap =  angular.copy($scope.localCommentFilterPreferenceMap);
        $scope.applyFeedbackFilters();
    };
}
}(angular, _));
